<template>
	<div class="mp-drawer-root" :class="{ 'is-open': open }">
		<div class="mp-drawer-mask" @click="closeLeft"></div>
		<div class="mp-drawer" @click.stop>
			<div class="mp-drawer__inner">
				<!-- guest head -->
				<div class="mp-drawer__head" v-if="!token">
					<div class="mp-drawer__brand">
						<img v-if="siteLogoUrl" class="mp-drawer__brand-logo" :src="siteLogoUrl" :alt="siteName" />
					</div>
					<button type="button" class="mp-drawer__close" @click="closeLeft" aria-label="close">×</button>
				</div>

				<!-- logged-in user head -->
				<div class="mp-drawer__user" v-else>
					<div class="mp-drawer__user-main">
						<div class="mp-drawer__avatar">
							<img src="@/assets/newimg/photo_v.webp" alt="" />
							<em class="mp-drawer__new">{{ vipBadge }}</em>
						</div>
						<div class="mp-drawer__user-meta">
							<div class="mp-drawer__user-name">{{ displayName }}</div>
							<div class="mp-drawer__user-id">ID: {{ info.id || '-' }}</div>
						</div>
					</div>
					<button type="button" class="mp-drawer__close" @click="closeLeft" aria-label="close">×</button>
				</div>

				<div class="mp-drawer__auth" v-if="!token">
					<button type="button" class="mp-drawer__btn mp-drawer__btn--reg" @click="openRegister">{{ $t('indexTitle.title1') }}</button>
					<button type="button" class="mp-drawer__btn mp-drawer__btn--login" @click="openLogin">{{ $t('indexTitle.title2') }}</button>
				</div>
				<template v-else>
					<div class="mp-drawer__auth">
						<button type="button" class="mp-drawer__btn mp-drawer__btn--reg" @click="goNextPage('/deposit')">{{ $t('indexTitle.title4') }}</button>
						<button type="button" class="mp-drawer__btn mp-drawer__btn--withdraw" @click="goNextPage('/withdraw')">{{ $t('indexTitle.title5') }}</button>
					</div>
					<div class="mp-drawer__stats">
						<div class="mp-drawer__stat" @click="goNextPage('/lossMoney')">
							<span>{{ $t('indexTitle.title696') || '退款损失' }}</span>
							<strong>{{ formatMoney(info.loss_money != null ? info.loss_money : info.fs_money) }}</strong>
						</div>
						<div class="mp-drawer__stat" @click="goNextPage('/invite')">
							<span>{{ $t('indexTitle.title36') || '佣金收入' }}</span>
							<strong>{{ formatMoney(info.agent_money) }}</strong>
						</div>
					</div>
					<div class="mp-drawer__invite" @click="copyInvite">
						<img src="@/assets/mepay77-home/assets/icons/menu-ico/3.png" alt="" />
						<span>{{ inviteShort }}</span>
						<svg class="mp-drawer__invite-copy" viewBox="0 0 24 24" fill="none" aria-hidden="true">
							<rect x="9" y="9" width="11" height="11" rx="2.2" fill="rgba(63,170,252,0.22)" stroke="#5EC8FF" stroke-width="1.7"/>
							<path d="M7 15V7.2A2.2 2.2 0 0 1 9.2 5H16" stroke="#5EC8FF" stroke-width="1.7" stroke-linecap="round"/>
							<rect x="4.5" y="4.5" width="11" height="11" rx="2.2" stroke="#fff" stroke-width="1.7"/>
						</svg>
					</div>
				</template>

				<div class="mp-drawer__list">
					<div class="mp-drawer__row" @click="goNextPage('/vip')">
						<img src="@/assets/mepay77-home/assets/icons/menu-ico/2.png" alt="" />
						<span>{{ $t('indexTitle.title25') || 'VIP' }}</span>
						<em>›</em>
					</div>
					<div class="mp-drawer__row" @click="goNextPage('/invite')">
						<img src="@/assets/mepay77-home/assets/icons/menu-ico/3.png" alt="" />
						<span>{{ $t('indexTitle.title28') || '邀请好友' }}</span>
						<em>›</em>
					</div>
					<div class="mp-drawer__row" @click="goNextPage('/vipRebates')">
						<img src="@/assets/mepay77-home/assets/icons/menu-ico/12.png" alt="" />
						<span>{{ $t('indexTitle.title695') || '退还您的游戏余额。' }}</span>
						<em>›</em>
					</div>
					<div class="mp-drawer__row" @click="goNextPage('/lossMoney')">
						<img src="@/assets/mepay77-home/assets/icons/menu-ico/13.png" alt="" />
						<span>{{ $t('indexTitle.title696') || '退款损失' }}</span>
						<em>›</em>
					</div>
					<div class="mp-drawer__row" @click="goNextPage('/promotions')">
						<img src="@/assets/mepay77-home/assets/icons/menu-ico/4.png" alt="" />
						<span>{{ $t('indexTitle.title14') || '优惠活动' }}</span>
						<em>›</em>
					</div>
					<div class="mp-drawer__row" @click="goNextPage('/bonusPool')">
						<img src="@/assets/mepay77-home/assets/icons/menu-ico/7.png" alt="" />
						<span>{{ $t('indexTitle.title45') || '特别奖励' }}</span>
						<em>›</em>
					</div>
				</div>

				<div class="mp-drawer__grid">
					<div class="mp-drawer__grid-item" @click="goNextPage('/deposit')">
						<img src="@/assets/mepay77-home/assets/icons/menu-ico/6.png" alt="" />
						<span>{{ $t('indexTitle.title4') || '充值' }}</span>
					</div>
					<div class="mp-drawer__grid-item" @click="goNextPage('/signin')">
						<img src="@/assets/mepay77-home/assets/icons/menu-ico/10.png" alt="" />
						<span>{{ $t('indexTitle.title348') || '签到' }}</span>
					</div>
					<div class="mp-drawer__grid-item" @click="goNextPage('/vipRebates')">
						<img src="@/assets/mepay77-home/assets/icons/menu-ico/9.png" alt="" />
						<span>{{ $t('indexTitle.title306') || '返水' }}</span>
					</div>
					<div class="mp-drawer__grid-item" @click="goNextPage('/turntable')">
						<img src="@/assets/mepay77-home/assets/icons/menu-ico/11.png" alt="" />
						<span>{{ $t('indexTitle.title318') || '转盘' }}</span>
					</div>
					<div class="mp-drawer__grid-item" @click="goNextPage('/game-historyTow')">
						<img src="@/assets/mepay77-home/assets/icons/menu-ico/8.png" alt="" />
						<span>{{ $t('indexTitle.title31') || '记录' }}</span>
					</div>
					<div class="mp-drawer__grid-item" @click="goNextPage('/promotion')">
						<img src="@/assets/mepay77-home/assets/icons/menu-ico/12.png" alt="" />
						<span>{{ $t('indexTitle.title32') || '财务' }}</span>
					</div>
					<div class="mp-drawer__grid-item" @click="goNextPage('/profile')">
						<img src="@/assets/mepay77-home/assets/icons/menu-ico/1.png" alt="" />
						<span>{{ $t('indexTitle.title123') || '资料' }}</span>
					</div>
					<div class="mp-drawer__grid-item" @click="getKefu">
						<img src="@/assets/mepay77-home/assets/icons/menu-ico/5.png" alt="" />
						<span>{{ $t('indexTitle.title210') || '联系我们' }}</span>
					</div>
					<div class="mp-drawer__grid-item" @click="langshow = true">
						<img class="mp-drawer__lang-flag" :src="currentLangFlag" alt="" />
						<span>{{ $t('indexTitle.title353') || '更改语言' }}</span>
					</div>
				</div>

				<button type="button" class="mp-drawer__logout" v-if="token" @click="loginOut">
					<i class="mdi-logout mdi" aria-hidden="true"></i>
					<span>{{ $t('indexTitle.title212') || 'Logout' }}</span>
				</button>
			</div>
		</div>

		<div class="wrapper" v-if="url">
			<div class="drag-container" ref="container">
				<img src="../assets/images/home.svg" alt="" :style="{
				  position: 'absolute',
				  left: img.x + 'px',
				  top: img.y + 'px',
				  cursor: 'move',
				  userSelect: 'none',
				  width: '40px',
				  height: '40px',
				  pointerEvents: 'auto',
				  /* 禁用浏览器默认拖拽 */
				  WebkitUserDrag: 'none',
				  userDrag: 'none',
				  zIndex:999	,
				}" @touchstart="startDrag" @mousedown="startDrag($event)" @click="url = ''" />
			</div>
			<iframe :src="url"></iframe>
		</div>

		<!-- 客服 -->
		<el-dialog :visible.sync="kefushow" center width="360px">
				<div class="w-full rounded-lg flex flex-col justify- text-white">
					<img data-nuxt-img="" src="@/assets/newimg/service_bg_v2.webp">
					<div class="bg-[#1c1c1c] py-5 px-3 rounded-lg mt-[20px]">
						<div class="pb-[10px] $-font-[600] text-[14px] lg:text-[16px]">{{$t('indexTitle.title304')}}</div>
						<div class="flex cursor-pointer mb-[10px] rounded-md items-center p-[10px] justify-between"
							@click="kefu(1)" style="background:rgb(38 38 38/var(--tw-bg-opacity,1))">
							<div class="flex items-center"><img data-nuxt-img="" class="size-[24px] mr-[10px] object-contain"
									:src="siteLogoUrl" alt="">
								<div class="text-[14px] lg:text-[16px] $-font-[600]">{{$t('indexTitle.title344')}}</div>
							</div>
							<div><i class="mdi-chevron-right mdi v-icon notranslate v-theme--light v-icon--size-default"
									aria-hidden="true"></i></div>
						</div>
						<div class="flex cursor-pointer mb-[10px] rounded-md items-center p-[10px] justify-between"
							@click="kefu(2)" style="background:rgb(38 38 38/var(--tw-bg-opacity,1))">
							<div class="flex items-center"><img data-nuxt-img="" class="size-[24px] mr-[10px] object-contain"
									:src="siteLogoUrl" alt="">
								<div class="text-[14px] lg:text-[16px] $-font-[600]">{{$t('indexTitle.title345')}}</div>
							</div>
							<div><i class="mdi-chevron-right mdi v-icon notranslate v-theme--light v-icon--size-default"
									aria-hidden="true"></i></div>
						</div>
					</div>
				</div>
		</el-dialog>
		<!-- 客服结束 -->
		<!--修改语言-->
		<div v-if="langshow" class="mp-lang-mask" @click.self="langshow = false">
			<div class="mp-lang-modal" role="dialog" aria-label="Change Language">
				<div class="mp-lang-modal__head">
					<span>Change Language</span>
					<button type="button" class="mp-lang-modal__close" @click="langshow = false" aria-label="close">×</button>
				</div>
				<div class="mp-lang-modal__body">
					<button type="button" class="mp-lang-tile" :class="{ 'is-active': $i18n.locale === 'en' }" @click="switchLang('en')">
						<span class="mp-lang-tile__check" v-if="$i18n.locale === 'en'">✓</span>
						<img src="@/assets/newimg/US.png" alt="" />
						<span>English</span>
					</button>
					<button type="button" class="mp-lang-tile" :class="{ 'is-active': $i18n.locale === 'th' }" @click="switchLang('th')">
						<span class="mp-lang-tile__check" v-if="$i18n.locale === 'th'">✓</span>
						<img src="@/assets/newimg/TH.png" alt="" />
						<span>ภาษาไทย</span>
					</button>
					<button type="button" class="mp-lang-tile" :class="{ 'is-active': $i18n.locale === 'zh' }" @click="switchLang('zh')">
						<span class="mp-lang-tile__check" v-if="$i18n.locale === 'zh'">✓</span>
						<img src="@/assets/newimg/CN.png" alt="" />
						<span>简体中文</span>
					</button>
				</div>
			</div>
		</div>
		<!--修改语言-->
		<!-- 客服 -->
		<el-dialog :visible.sync="aboutdetailshow" center width="360px">
			<div v-html="abouthtml.content" style="height:400px;overflow-y:scroll;scrollbar-width: none;-ms-overflow-style: none;"></div>
		</el-dialog>
		<!-- 客服 -->
	</div>
</template>

<script>
	import {
		eventBus
	} from '@/App.vue'
	import {
		userinfo,
		getsystemconfig,
		transferAll,
		about,
		aboutDetail
	} from "../utils/api.js";
	import { resolveMediaUrl } from "@/utils/mediaUrl.js";
	export default {
		props: {
			open: {
				type: Boolean,
				default: false,
			},
		},
		watch: {
			open(val) {
				if (typeof document === 'undefined') return
				document.body.style.overflow = val ? 'hidden' : ''
			},
		},
		beforeDestroy() {
			if (typeof document !== 'undefined') {
				document.body.style.overflow = ''
			}
		},
		data() {
			return {
				token: !!localStorage.getItem('token'),
				isrefresh: "",
				isShowLang: false,
				isShowyue: false,
				info: {},
				tran: true,
				isloadingTowShow: false,
				kefushow: false,
				img: {
					x: 40,
					y: 60
				},
				isDragging: false,
				offsetX: 0,
				offsetY: 0,
				dragMask: null,
				systemconfig: {},
				isLoadingShow: false,
				url: "",
				loginShow: false,
				registerShow: false,

				name: '',
				password: '',

				namesmall: '',
				psdsamll: '',
				isShowOness: false,
				isShowTowss: false,
				isShowThreess: false,
				messageText: "",
				activitId: true,
				passwordtype: 'password',
				currentPath: "",
				langshow: false,
				aboutshow: false,
				aboutlist:[],
				abouthtml:'',
				aboutdetailshow:false,
			}
		},
		computed: {
			siteName() {
				const name = (this.systemconfig && this.systemconfig.site_name) || ''
				return String(name).trim() || 'U66888'
			},
			siteLogoUrl() {
				const raw = (this.systemconfig && this.systemconfig.m_site_logo) || ''
				return resolveMediaUrl(raw)
			},
			displayName() {
				const n = this.info || {}
				return n.name || n.phone || n.username || '-'
			},
			vipBadge() {
				const lv = this.info && this.info.level
				const n = parseInt(lv, 10)
				return 'VIP' + (isNaN(n) ? 0 : n)
			},
			inviteUrl() {
				const code = (this.info && this.info.invite_code) || ''
				const base = (typeof window !== 'undefined' && window.location && window.location.origin) || ''
				return code ? (base + '/register?invite_code=' + code) : (base + '/register')
			},
			inviteShort() {
				const u = this.inviteUrl.replace(/^https?:\/\//, '')
				return u.length > 28 ? (u.slice(0, 28) + '...') : u
			},
			currentLangFlag() {
				const map = {
					en: require('@/assets/newimg/US.png'),
					th: require('@/assets/newimg/TH.png'),
					zh: require('@/assets/newimg/CN.png'),
					ft: require('@/assets/newimg/CN.png'),
				}
				return map[this.$i18n.locale] || map.th
			},
		},
		created() {},
		mounted() {
			if (localStorage.getItem("token") && !localStorage.getItem("userInfo")) {
				this.getuserinfo();
			} else if (localStorage.getItem("token") && localStorage.getItem("userInfo")) {
				this.info = JSON.parse(localStorage.getItem('userInfo'))
				this.getuserinfo();
			} else {
				this.token = false;
			}
			this.getSystemconfig();
			this.$bus.$on('loginStateChanged', this.syncLoginFromBus)
			this.$bus.$on('refreshUserInfo', this.syncLoginFromBus)
			window.location.href.indexOf("?show") > -1 ? this.isLoadingShow = true : ''
			this.currentPath = this.$route.path
			// 路由切换时自动更新高亮
			this.$watch('$route.path', (to) => {
				this.currentPath = to
			})
		},
		methods: {
			closeLeft() {
				// 触发事件总线，强制把侧边栏状态设为 false（隐藏）
				eventBus.$emit('toggleLeft', false)
			},
			openLogin() {
				this.closeLeft()
				this.$router.push('/login')
			},
			openRegister() {
				this.closeLeft()
				this.$router.push('/register')
			},
			getEventClientXY(e) {
				if (e.type.startsWith('touch')) {
					// touch 事件：e.touches[0]
					const touch = e.touches[0] || e.changedTouches[0];
					return {
						x: touch.clientX,
						y: touch.clientY
					};
				} else {
					// mouse 事件
					return {
						x: e.clientX,
						y: e.clientY
					};
				}
			},

			startDrag(e) {
				const imgRect = e.target.getBoundingClientRect();
				const {
					x: clientX,
					y: clientY
				} = this.getEventClientXY(e);
				this.isDragging = true;
				this.offsetX = clientX - imgRect.left;
				this.offsetY = clientY - imgRect.top;
				if (!this.dragMask) {
					this.dragMask = document.createElement('div');
					this.dragMask.style.cssText = `
			        position: fixed;
			        top: 0; left: 0;
			        width: 100vw; height: 100vh;
			        z-index: 99998;
			        pointer-events: none;
			      `;
					document.body.appendChild(this.dragMask);
				}
				document.addEventListener('mousemove', this.onDragMove);
				document.addEventListener('touchmove', this.onDragMove, {
					passive: false
				});
				document.addEventListener('mouseup', this.stopDrag);
				document.addEventListener('touchend', this.stopDrag);
			},
			tiyu() {
				// this.$bus.$emit('openUrlModal')
				this.$bus.$emit('openTiyu')
			},
			onDragMove(e) {
				if (!this.isDragging) return;
				e.preventDefault(); // 阻止页面滚动
				const {
					x: clientX,
					y: clientY
				} = this.getEventClientXY(e);
				const containerRect = this.$refs.container.getBoundingClientRect();

				let newX = clientX - this.offsetX;
				let newY = clientY - this.offsetY;

				newX = Math.max(0, Math.min(newX, containerRect.width - 40));
				newY = Math.max(0, Math.min(newY, containerRect.height - 40));

				this.img.x = newX;
				this.img.y = newY;
			},

			stopDrag() {
				this.isDragging = false;
				document.removeEventListener('mousemove', this.onDragMove);
				document.removeEventListener('touchmove', this.onDragMove);
				document.removeEventListener('mouseup', this.stopDrag);
				document.removeEventListener('touchend', this.stopDrag);

				if (this.dragMask) {
					document.body.removeChild(this.dragMask);
					this.dragMask = null;
				}
			},
			getuserinfo() {
				userinfo()
					.then((res) => {
						if (res.status.errorCode == 0) {
							this.info = res.data;
							localStorage.setItem("userInfo", JSON.stringify(this.info))
							this.token = true;
							this.isShowyue = false;
							this.isloadingTowShow = false;
						} else if (res.status.errorCode == 401) {
							this.token = false;
							localStorage.removeItem("token");
							localStorage.removeItem('siteTitle');
							localStorage.removeItem('siteIco');
							if (localStorage.getItem('languageTow')) {
								localStorage.removeItem('languageTow');
							}
							if (localStorage.getItem("language")) {
								localStorage.removeItem("language");
							}
							if (localStorage.getItem("userInfo")) {
								localStorage.removeItem("userInfo");
							}
						} else {
							this.token = false;
							// this.$message.error(res.status.msg);
							this.msgTextTow = res.status.msg;
							this.isShowLoadingTeow = true;
							setTimeout(() => {
								this.isShowLoadingTeow = false;
							}, 2000)
							// this.$message({
							// 	showClose: true,
							// 	message: res.status.msg,
							// 	type: "error",
							// });
						}
					})
					.catch((err) => {
						console.log(err, "err");
					});
			},
			getrefresh() {
				this.isrefresh = true;
				this.getuserinfo();
			},
			getShowLang() {
				this.isShowLang = !this.isShowLang;
			},
			getShowYue() {
				this.isShowyue = !this.isShowyue;
			},
			jixuAPI() {
				var that = this;
				if (!that.tran) {
					return;
				}
				that.tran = false;
				this.isloadingTowShow = true;
				transferAll({})
					.then((res) => {
						that.tran = true;
						if (res.status.errorCode == 0) {
							this.getuserinfo();
							this.$message({ showClose: true, message: 'OK', type: 'success' })
							this.closeLeft()
						} else {
							this.msgTextTow = res.status.msg;
							this.isShowLoadingTeow = true;
							setTimeout(() => {
								this.isShowLoadingTeow = false;
							}, 2000)
							// this.$message({
							// 	showClose: true,
							// 	message: res.status.msg,
							// 	type: "error",
							// });
						}
					})
					.catch((err) => {
						console.log(err, "err");
					});
			},
			switchLang(lang) {
				if (lang == 'zh') {
					localStorage.setItem("languageTow", 'zh_cn');
				} else if (lang == 'th') {
					localStorage.setItem("languageTow", 'th');
				} else {
					localStorage.setItem("languageTow", lang);
				}
				this.$i18n.locale = lang;
				localStorage.setItem("language", lang);

				this.isShowLang = false;
				this.langshow = false;
				this.getNoticeList();
				this.getSystemconfig();
				if (localStorage.getItem("token") && !localStorage.getItem("userInfo")) {
					this.getuserinfo();
				} else if (localStorage.getItem("token") && localStorage.getItem("userInfo")) {
					this.info = JSON.parse(localStorage.getItem('userInfo'))
					this.getuserinfo();
				} else {
					this.token = false;
				}
				this.navList = [{
						title: this.$t("indexTitle.title6"),
						img: require("@/assets/images/tiyu.webp"),
					},
					{
						title: this.$t("indexTitle.title7"),
						img: require("@/assets/images/zhenren.webp"),
					},
					{
						title: this.$t("indexTitle.title8"),
						img: require("@/assets/images/laohuji.webp"),
					},
					{
						title: this.$t("indexTitle.title9"),
						img: require("@/assets/images/qipai.webp"),
					},
					{
						title: this.$t("indexTitle.title10"),
						img: require("@/assets/images/buyu.webp"),
					},

					{
						title: this.$t("indexTitle.title12"),
						img: require("@/assets/images/dianjing.webp"),
					},
					{
						title: this.$t("indexTitle.title11"),
						img: require("@/assets/images/dongwujingji.webp"),
					},
					// {
					// 	"title": this.$t("indexTitle.title13"),
					// 	"img": require('@/assets/images/caipiao.webp')
					// },
					{
						title: this.$t("indexTitle.title14"),
						img: require("@/assets/images/youhuihuodong.webp"),
					},
					{
						title: this.$t("indexTitle.title15"),
						img: require("@/assets/images/shoujixiazai.png"),
					},
				]

			},
			syncLoginFromBus() {
				if (localStorage.getItem('token')) {
					this.token = true
					if (localStorage.getItem('userInfo')) {
						try {
							this.info = JSON.parse(localStorage.getItem('userInfo'))
						} catch (e) {
							this.info = {}
						}
					}
					this.getuserinfo()
				} else {
					this.token = false
					this.info = {}
				}
			},
			formatMoney(v) {
				const n = parseFloat(v)
				if (isNaN(n)) return '0.00'
				return n.toFixed(2)
			},
			copyInvite() {
				const text = this.inviteUrl
				const done = () => {
					this.$message({ showClose: true, message: 'Copied', type: 'success' })
				}
				if (navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(text).then(done).catch(() => {
						window.prompt('Copy', text)
					})
				} else {
					window.prompt('Copy', text)
				}
			},
			loginOut() {
				localStorage.removeItem('token');
				localStorage.removeItem('siteTitle');
				localStorage.removeItem('siteIco');
				if (localStorage.getItem('languageTow')) localStorage.removeItem('languageTow');
				if (localStorage.getItem('language')) localStorage.removeItem('language');
				if (localStorage.getItem('userInfo')) localStorage.removeItem('userInfo');
				if (localStorage.getItem('tongjilistTow')) localStorage.removeItem('tongjilistTow');
				this.token = false
				this.info = {}
				document.body.classList.remove('is-logged-in')
				this.closeLeft()
				this.$bus.$emit('refreshUserInfo')
				location.href = '/'
			},
			goNextPage(page) {
				const needLogin = [
					'/deposit',
					'/withdraw',
					'/vipRebates',
					'/lossMoney',
					'/bankcards',
					'/game-historyTow',
					'/finan-history',
					'/promotion',
					'/personalMsg',
					'/turntable',
					'/profile',
					'/vip',
					'/invite',
					'/signin',
				]
				if (!localStorage.getItem('token') && needLogin.indexOf(page) !== -1) {
					this.$bus.$emit('openLoginModal')
					return false;
				}
				this.$router.push(page);
				this.closeLeft()
			},
			getKefu() {
				this.closeLeft();
				this.$router.push('/contact');
				return false;
			},
			getSystemconfig() {
				getsystemconfig()
					.then((res) => {
						if (res.status.errorCode == 0) {
							this.systemconfig = res.data || {};
						}
					})
					.catch((err) => {
						console.log(err, "err");
					});
			},
			kefu(type) {
				var wyWindow = "";

				if (type == 1) {
					// this.url = this.systemconfig.service_link;
					this.$bus.$emit('openKefu')
				} else {
					wyWindow = window.open(location.href + '?show=1', "_blank");
					wyWindow.location = this.systemconfig.service_link2;
				}
			},
			closeGuanbi() {
				this.kefushow = false;
			},
			aboutdo(){
				this.aboutshow = !this.aboutshow;
				if(this.aboutshow){
					about({})
						.then((res) => {
							this.aboutlist = res.data
						})
						.catch((err) => {
							console.log(err, "err");
						});
				}
				
			},
			aboutdetaildo(id){
				aboutDetail({id:id}).then((res) => {
					if (res.status.errorCode == 0) {
						this.aboutdetailshow = true;
						console.log(res.data);
						this.abouthtml = res.data;
					} else {
						this.$message({
							showClose: true,
							message: res.status.msg,
							type: 'error'
						});
					}
				}).catch((err) => {
					console.log(err, 'err')
				});
			}
		}
	}
</script>
<style scoped>
.mp-drawer-root {
	position: fixed;
	inset: 0;
	z-index: 400;
	pointer-events: none;
	visibility: hidden;
}
.mp-drawer-root.is-open {
	pointer-events: auto;
	visibility: visible;
}
.mp-drawer-mask {
	position: absolute;
	inset: 0;
	background: rgba(0, 0, 0, 0.55);
	opacity: 0;
	transition: opacity 0.28s ease;
	cursor: pointer;
}
.mp-drawer-root.is-open .mp-drawer-mask {
	opacity: 1;
}
.mp-drawer {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	z-index: 1;
	width: min(86vw, 340px);
	border-radius: 0 18px 18px 0;
	background: #121212;
	box-shadow: 8px 0 28px rgba(0, 0, 0, 0.45);
	height: 100%;
	max-height: 100dvh;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	padding-top: env(safe-area-inset-top, 0px);
	padding-bottom: env(safe-area-inset-bottom, 0px);
	box-sizing: border-box;
	transform: translateX(-105%);
	transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}
.mp-drawer-root.is-open .mp-drawer {
	transform: translateX(0);
}
@media (min-width: 768px) {
	.mp-drawer {
		width: min(380px, 32vw);
		border-radius: 0 22px 22px 0;
		background: #151515;
	}
}
.mp-drawer__inner {
	min-height: 100%;
	padding: 14px 12px 40px;
	box-sizing: border-box;
}
.mp-drawer__head {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 40px;
	margin-bottom: 12px;
}
.mp-drawer__brand {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	line-height: 0;
	max-width: calc(100% - 48px);
	overflow: hidden;
}
.mp-drawer__brand-logo {
	display: block;
	height: 36px;
	width: auto;
	max-width: 100%;
	object-fit: contain;
	margin: 0 auto;
}
.mp-drawer__head .mp-drawer__close {
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
}
.mp-drawer__user {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 8px;
	margin-bottom: 14px;
}
.mp-drawer__user-main {
	display: flex;
	align-items: center;
	gap: 10px;
	min-width: 0;
}
.mp-drawer__avatar {
	position: relative;
	width: 52px;
	height: 52px;
	flex-shrink: 0;
}
.mp-drawer__avatar img {
	width: 52px;
	height: 52px;
	border-radius: 50%;
	object-fit: cover;
	background: #2a2a2a;
}
.mp-drawer__new {
	position: absolute;
	top: -2px;
	right: -10px;
	font-style: normal;
	font-size: 9px;
	font-weight: 800;
	color: #fff;
	background: var(--mp-orange, #3faafc);
	border-radius: 999px;
	padding: 1px 5px;
	line-height: 1.3;
	white-space: nowrap;
	letter-spacing: 0.2px;
}
.mp-drawer__user-meta {
	min-width: 0;
}
.mp-drawer__user-name {
	color: #fff;
	font-size: 16px;
	font-weight: 800;
	line-height: 1.2;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.mp-drawer__user-id {
	display: inline-flex;
	margin-top: 6px;
	padding: 2px 8px;
	border-radius: 999px;
	background: rgba(34, 197, 94, 0.18);
	color: #22c55e;
	font-size: 11px;
	font-weight: 700;
}
.mp-drawer__close {
	border: 0;
	background: transparent;
	color: #fff;
	font-size: 30px;
	line-height: 1;
	padding: 0 4px;
	cursor: pointer;
}
.mp-drawer__auth {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
	margin-bottom: 12px;
}
.mp-drawer__btn {
	height: 44px;
	border: 0;
	border-radius: 14px;
	color: #fff;
	font-size: 16px;
	font-weight: 700;
	cursor: pointer;
}
.mp-drawer__btn--reg {
	background: var(--mp-gradient-cta-reg);
	box-shadow: var(--mp-shadow-glow);
}
.mp-drawer__btn--login {
	background: var(--mp-gradient-cta-login);
	box-shadow: 0 6px 14px rgba(37, 117, 252, 0.28);
}
.mp-drawer__btn--withdraw {
	background: transparent;
	border: 1.5px solid rgba(94, 200, 255, 0.65);
	color: #8ad8ff;
	box-shadow: none;
}
.mp-drawer__stats {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 8px;
	margin-bottom: 10px;
}
.mp-drawer__stat {
	background: #1c1c1c;
	border: 1px solid rgba(255, 255, 255, 0.06);
	border-radius: 12px;
	padding: 10px 10px 8px;
	display: flex;
	flex-direction: column;
	gap: 4px;
	cursor: pointer;
}
.mp-drawer__stat span {
	color: #9a9a9a;
	font-size: 11px;
	font-weight: 600;
}
.mp-drawer__stat strong {
	color: #22c55e;
	font-size: 16px;
	font-weight: 800;
}
.mp-drawer__invite {
	display: flex;
	align-items: center;
	gap: 8px;
	min-height: 42px;
	padding: 0 10px;
	margin-bottom: 12px;
	border-radius: 12px;
	background: #1c1c1c;
	border: 1px solid rgba(255, 255, 255, 0.06);
	cursor: pointer;
}
.mp-drawer__invite img {
	width: 22px;
	height: 22px;
	object-fit: contain;
	flex-shrink: 0;
}
.mp-drawer__invite span {
	flex: 1;
	min-width: 0;
	color: #fff;
	font-size: 12px;
	font-weight: 600;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.mp-drawer__invite svg,
.mp-drawer__invite-copy {
	width: 18px;
	height: 18px;
	flex-shrink: 0;
}
.mp-drawer__list {
	background: #1c1c1c;
	border-radius: 16px;
	overflow: hidden;
	margin-bottom: 12px;
	border: 1px solid rgba(255, 255, 255, 0.06);
}
.mp-drawer__logout {
	margin-top: 14px;
	width: 100%;
	height: 46px;
	border-radius: 12px;
	border: 1.5px solid rgba(248, 113, 113, 0.65);
	background: rgba(127, 29, 29, 0.35);
	color: #fca5a5;
	font-size: 15px;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	cursor: pointer;
}
.mp-drawer__logout .mdi {
	font-size: 18px;
}
.mp-drawer__row {
	display: flex;
	align-items: center;
	gap: 10px;
	min-height: 48px;
	padding: 0 12px;
	color: #fff;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}
.mp-drawer__row:last-child { border-bottom: 0; }
.mp-drawer__row:active { background: rgba(63, 170, 252, 0.12); }
.mp-drawer__row img {
	width: 26px;
	height: 26px;
	object-fit: contain;
	flex-shrink: 0;
}
.mp-drawer__row span {
	flex: 1;
	min-width: 0;
	line-height: 1.25;
}
.mp-drawer__row em {
	font-style: normal;
	color: rgba(255, 255, 255, 0.45);
	font-size: 20px;
	line-height: 1;
}
.mp-drawer__grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 10px 6px;
	background: #1c1c1c;
	border-radius: 16px;
	padding: 14px 8px 12px;
	border: 1px solid rgba(255, 255, 255, 0.06);
}
.mp-drawer__grid-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 5px;
	color: #fff;
	font-size: 11px;
	font-weight: 600;
	text-align: center;
	cursor: pointer;
	line-height: 1.2;
	min-height: 64px;
}
.mp-drawer__grid-item img {
	width: 28px;
	height: 28px;
	object-fit: contain;
}
.mp-drawer__lang-flag {
	width: 28px;
	height: 28px;
	border-radius: 50%;
	object-fit: cover;
	border: 1.5px solid rgba(94, 200, 255, 0.45);
	box-shadow: 0 3px 8px rgba(37, 117, 252, 0.28);
}

.mp-lang-mask {
	position: fixed;
	inset: 0;
	z-index: 2000;
	background: rgba(0, 0, 0, 0.62);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
}
.mp-lang-modal {
	width: min(340px, 100%);
	border-radius: 18px;
	overflow: hidden;
	background: #1a1a1a;
	box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
}
.mp-lang-modal__head {
	position: relative;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: var(--mp-gradient-cta-reg);
	color: #fff;
	font-size: 17px;
	font-weight: 700;
}
.mp-lang-modal__close {
	position: absolute;
	right: 12px;
	top: 50%;
	transform: translateY(-50%);
	border: 0;
	background: transparent;
	color: #fff;
	font-size: 28px;
	line-height: 1;
	padding: 0 4px;
	cursor: pointer;
}
.mp-lang-modal__body {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 12px;
	padding: 18px 14px 20px;
	background: #151515;
}
.mp-lang-tile {
	position: relative;
	border: 1px solid #2a2a2a;
	background: #222;
	border-radius: 14px;
	padding: 14px 6px 12px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	color: #fff;
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	min-height: 104px;
}
.mp-lang-tile img {
	width: 42px;
	height: 42px;
	border-radius: 50%;
	object-fit: cover;
}
.mp-lang-tile.is-active {
	border-color: var(--mp-orange, #f87171);
	box-shadow: 0 0 0 1px rgba(251, 113, 133, 0.55), 0 0 12px rgba(244, 63, 94, 0.35);
}
.mp-lang-tile__check {
	position: absolute;
	top: 6px;
	right: 6px;
	width: 18px;
	height: 18px;
	border-radius: 50%;
	background: var(--mp-orange, #f87171);
	color: #fff;
	font-size: 11px;
	font-weight: 800;
	line-height: 18px;
	text-align: center;
}

	.wrapper {
		position: fixed;
		width: 100%;
		min-height: 100%;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		z-index: 999999;
		background: #000;
	}

	iframe {
		width: 100%;
		height: 100%;
		border: 0;
	}
</style>
